const pubsub = window.DR.pubsub;

function toggleContents(selector) {

  $(selector).each(function each() {
    const toggle = $(this);
    const hrefAttrValue = toggle.attr('href');
    const clones = $(`a[href="${hrefAttrValue}"]`);
    const content = $(hrefAttrValue)[0];
    let hidden = false;

    function hide() {
      content.style.display = 'none';
      clones.removeClass('active');
      hidden = true;
      pubsub.emit('togglecontents', content, false);
    }

    function show() {
      content.style.display = 'block';
      clones.addClass('active');
      hidden = false;
      pubsub.emit('togglecontents', content, true);
    }

    hide();

    toggle.click((e) => {
      e.preventDefault();
      e.stopPropagation();
      if (hidden) {
        show();
      } else {
        hide();
      }
    });
  });
}

module.exports = {
  toggleContents: function(selector) {
    toggleContents(selector);
  }
};
